'use strict';//Indicating browser should run only in java script mode

var EMRSession = angular.module('EMR.Session', ['EMR.Admin', 'ngIdle', 'ui.bootstrap'])